export const getDashboardData = (filter) => ({
    method: "get",
    url: `dashboard`
  })